import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { rem } from 'polished';
import API from '../../services/API';
import { __, __r } from '@bart.sk-eshop/react-i18n';
import { withRouter, WithRouterProps } from 'react-router';
import {
  ErrorAlert,
  ZemplinTitle as Title,
} from '@bart.sk-eshop/eshop-defaults';
import { Loader } from '@bart.sk-eshop/eshop-defaults/lib';
import { LogoutButton } from './MyAccount';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import {
  setBreadCrumbPath,
  BreadCrumbType,
} from '../BreadCrumb/breadCrumbSlice';
import { prop } from '../../utilities';

const Wrapper = styled.div`
  width: 100%;
  max-width: ${rem(320)};
  padding: 0;
  background-color: white;
  margin: 0 auto;
  border-radius: ${rem(4)};

  ${({ theme }) => theme.mediab.l925`
   padding-top: ${rem(24)};
  `}
`;

const EmailWrapper = styled.div`
  margin-bottom: ${rem(10)};
`;

const AuthButtonWrapper = styled.div`
  margin-bottom: ${rem(25)};
`;

const SuccessTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(25)};
  color: ${({ theme }) => theme.color.success};
`;

const PasswordInput = styled.input<{ isMobile: boolean }>`
  display: block;
  width: 100%;
  background: ${({ theme }) => theme.color.white};
  border-radius: ${rem(2)};
  padding: ${rem(16)};
  box-shadow: ${({ theme }) => theme.boxShadow.input};
  border: ${({ isMobile }) => (isMobile ? 'none' : '1px solid #cccccc')};
  height: ${rem(48)};
  max-width: ${({ isMobile }) => (isMobile ? 'initial' : rem(450))};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 300;
  font-family: ${({ theme }) => theme.font.secondary};

  &:disabled {
    cursor: not-allowed;
  }

  &::placeholder {
    font-family: ${({ theme }) => theme.font.secondary};
    color: ${({ theme }) => theme.colors.placeholder};
    font-weight: 300;
  }
`;

const ChangePasswordButton = styled(LogoutButton)`
  max-width: ${rem(320)};
  width: 100%;
`;

interface NewPasswordBoxPropsIO {
  token: string;
  onOk: () => void;
  onSignUpLinkClick: () => void;
  dispatch: (a: any) => void;
  user: any;
}

interface State {
  password: string;
  confirmPassword: string;
  oldPassword: string;
  error: string;
  passwordChanged: boolean;
  fetching: boolean;
}

class ChangePassword extends React.Component<
  NewPasswordBoxPropsIO & WithRouterProps,
  State
> {
  public static async getInitialProps({ dispatch }) {
    dispatch(setBreadCrumbPath(BreadCrumbType.MY_ACCOUNT_CHANGE_PASSWORD));
    return;
  }

  constructor(props) {
    super(props);

    this.state = {
      password: '',
      confirmPassword: '',
      oldPassword: '',
      error: '',
      passwordChanged: false,
      fetching: false,
    };
  }

  public onSetPasswordClick = async () => {
    const { user } = this.props;
    const { password, confirmPassword, oldPassword } = this.state;
    if (password === confirmPassword) {
      try {
        this.setState({ fetching: true });
        await API.changePassword(
          prop(user, 'id'),
          {},
          {
            new_password: password,
            current_password: oldPassword,
            password_check: confirmPassword,
          },
        );
        this.setState({ passwordChanged: true, fetching: false });
      } catch (exp) {
        this.setState({ error: exp.details.description, fetching: false });
      }
    } else {
      this.setState({ error: 'Heslá sa nezhodujú', fetching: false });
    }
  };

  public onPasswordChanged = e => {
    this.setState({ password: e.target.value });
  };

  public onConfirmPasswordChanged = e => {
    this.setState({ confirmPassword: e.target.value });
  };

  public onOldPasswordChanged = e => {
    this.setState({ oldPassword: e.target.value });
  };

  public onOk = () => {
    this.setState({ passwordChanged: false, error: '' });
    this.props.router.push(
      __r('routes:moj-ucet/moje-udaje', '/moj-ucet/moje-udaje'),
    );
  };

  public render() {
    const {
      password,
      confirmPassword,
      oldPassword,
      error,
      fetching,
    } = this.state;
    return (
      <Loader loading={fetching}>
        <Wrapper>
          {!this.state.passwordChanged ? (
            <>
              {' '}
              {error ? <ErrorAlert message={error} /> : ''}
              <Title marginTop={0}>{__('Zmena aktuálneho hesla')}</Title>
              <EmailWrapper>
                <PasswordInput
                  type="password"
                  placeholder={__('Staré heslo')}
                  onChange={this.onOldPasswordChanged}
                  value={oldPassword}
                  name="old-password"
                />
              </EmailWrapper>
              <EmailWrapper>
                <PasswordInput
                  type="password"
                  placeholder={__('Nové heslo')}
                  onChange={this.onPasswordChanged}
                  value={password}
                  name="new-password"
                />
              </EmailWrapper>
              <EmailWrapper>
                <PasswordInput
                  type="password"
                  placeholder={__('Potvrdenie nového hesla')}
                  onChange={this.onConfirmPasswordChanged}
                  value={confirmPassword}
                  name="confirm-password"
                />
              </EmailWrapper>
              <AuthButtonWrapper>
                <ChangePasswordButton onClick={this.onSetPasswordClick}>
                  {' '}
                  {__('Zmeniť heslo')}{' '}
                </ChangePasswordButton>
              </AuthButtonWrapper>
            </>
          ) : (
            <div>
              <SuccessTextWrapper>
                {__('Heslo bolo úspešne zmenené')}
              </SuccessTextWrapper>
              <AuthButtonWrapper>
                <ChangePasswordButton onClick={this.onOk}>
                  {' '}
                  OK{' '}
                </ChangePasswordButton>
              </AuthButtonWrapper>
            </div>
          )}
        </Wrapper>
      </Loader>
    );
  }
}

const mapStateToProps = state => {
  return { user: state.auth.user };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'ChangePassword' })(withRouter(ChangePassword)),
);
